// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import FunnelStepsSvg from '@rsuite/icon-font/lib/charts/FunnelSteps';
var FunnelSteps = createSvgIcon({
  as: FunnelStepsSvg,
  ariaLabel: 'funnel steps',
  category: 'charts',
  displayName: 'FunnelSteps'
});
export default FunnelSteps;